import { Loading } from "@mnk/frontend/components/Loading";
import { SideMenu } from "@mnk/frontend/components/pages/settings/sideMenu";
import { EditForm } from "@mnk/frontend/components/pages/settings/users/EditForm";
import { trpc } from "@mnk/frontend/lib/trpc";
import { NotFound } from "@mnk/frontend/pages/NotFound";
import { useParams } from "react-router-dom";

export const UsersEditSetting = () => {
  const getMe = trpc.getUser.useQuery();
  const me = getMe.data;

  if (getMe.isLoading) return <Loading />;
  if (me?.role !== "admin") return <NotFound />;

  const { id } = useParams();
  if (!id) return <NotFound />;

  const getUser = trpc.getUserById.useQuery(id);
  const user = getUser.data;

  if (getUser.isLoading) return <Loading />;
  if (!user) return <NotFound />;

  return (
    <div className="flex max-w-[1080px] mx-auto pt-8 px-4">
      <SideMenu />
      <EditForm user={user} />
    </div>
  );
};
